import { post } from "../config";

export async function GenerateJWTToken(clientId) {
  const response = await post({ url: `/api/auth/generate-jwt`, body: { clientId } });
  console.log(response)
  return response;
}
